import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import Flash from "../flash/Flash.jsx"

export default function AdminImagesShow({image, status}) {
  const [flashMessage, setFlashMessage] = useState("")

  useEffect(() => {
    if (status === "created") {
      setFlashMessage("Image was successfully created")
    } else if (status === "updated") {
      setFlashMessage("Image was successfully updated")
    }

    window.history.replaceState(null, "Admin - Image" , '/cocofantoelefanto/images/' + image.id)
  }, [image.id, status])

  return(
    <>
      <h1>Show Image</h1>
      {flashMessage !== "" && (
        <Flash message={flashMessage} type="success"/>
      )}

      <div className="flex flex-col mt-4">
        <div id="images" className={`flex flex-row mt-4`}>
          <b>Nome do arquivo:</b>
          <span className="ml-4">{ image.filename }</span>
        </div>
      </div>

      <div id="actions" className="w-full pt-4 mt-4 space-x-2">
        <Link className="hover:no-underline underline" to="/cocofantoelefanto/images">Back to Images</Link>
        <span>|</span>
        <Link className="hover:no-underline underline" to="/cocofantoelefanto/images/new">Create New Image</Link>
      </div>

    </>
  )
}
